import { useContext } from 'react';
import { MapSearchContext } from 'context/MapSearchContext';
import { SearchIcon } from '@medly-components/icons';
import { MapTourContext } from 'context/MapTourContext';

export const MapSearchIcon = () => {
    const { setIsMapTour } = useContext(MapTourContext);
    const { setIsMapSearch } = useContext(MapSearchContext);

    const startSearch = () => {
        setIsMapSearch(true);
        setIsMapTour(false);
    };

    return <SearchIcon data-testid="map-search-icon" onClick={startSearch} />;
};

MapSearchIcon.displayName = 'MapSearchIcon';
